import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private msalService: MsalService) {}

  getLoggedInUser(): AccountInfo | null {
    const accounts = this.msalService.instance.getAllAccounts();
    return accounts.length > 0 ? accounts[0] : null;
  }

  getUserName(): string {
    const user = this.getLoggedInUser();
    return user?.name || 'Unknown User';
  }

  getUserEmail(): string {
    const user = this.getLoggedInUser();
    return user?.username || '';
  }
}
